/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, TextField } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { regexIBAN, regexSeriesAndNumber } from "../../Utils/Constants";
import { useState } from "react";

type CustomerPersonalDataProps = {
  title: string;
  gridSize: number;
  customer: any;
  handleChangeCustomerDetails: (customerDetails: any) => void;
};

export default function CustomerPaymentInfo(props: CustomerPersonalDataProps) {
  const { title, gridSize, customer, handleChangeCustomerDetails } = props;

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  /**
   *
   * @param value
   * @param name
   */
  const validateField = (value: string, name: string) => {
    let errorMessage = "";

    if (name === "iban") {
      const regexIBANExp = new RegExp(regexIBAN);
      if (!regexIBANExp.test(value)) {
        errorMessage = Vocabulary.ibanMessageError;
      }
    }
    if (name === "seriesAndNumber") {
      const regexSeriesAndNumberExp = new RegExp(regexSeriesAndNumber);
      if (!regexSeriesAndNumberExp.test(value)) {
        errorMessage = Vocabulary.seriesAndNumberMessageError;
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };
  return (
    <Grid item xs={12} md={gridSize} lg={gridSize}>
      <div
        style={{
          padding: 15,
        }}
      >
        <h3 style={{ margin: 10 }}>{title}</h3>
        <TextField
          type="text"
          name="accountFullName"
          label={Vocabulary.accountFullName}
          variant="standard"
          fullWidth
          value={customer.personalData.accountFullName}
          onChange={(e) => {
            const newCustomer = structuredClone(customer);
            newCustomer.personalData.accountFullName = e.target.value;
            handleChangeCustomerDetails(newCustomer);
          }}
          style={{ margin: "10px 0px" }}
        />
        <TextField
          type="text"
          name="iban"
          label={Vocabulary.iban}
          variant="standard"
          fullWidth
          value={customer.personalData.iban}
          onChange={(e) => {
            let newValue = e.target.value;
            newValue = e.target.value.toUpperCase().replace(/\s/g, "");
            const newCustomer = structuredClone(customer);
            newCustomer.personalData.iban = newValue;
            handleChangeCustomerDetails(newCustomer);
            validateField(e.target.value, e.target.name);
          }}
          style={{ margin: "10px 0px" }}
          error={!!errors["iban"]}
          helperText={errors["iban"]}
        />
        <TextField
          type="text"
          name="seriesAndNumber"
          label={Vocabulary.seriesAndNumber}
          variant="standard"
          fullWidth
          value={customer.personalData.seriesAndNumber}
          onChange={(e) => {
            let newValue = e.target.value;

            newValue = e.target.value.toUpperCase().replace(/\s/g, "");
            const newCustomer = structuredClone(customer);
            newCustomer.personalData.seriesAndNumber = newValue;
            handleChangeCustomerDetails(newCustomer);
            validateField(e.target.value, e.target.name);
          }}
          style={{ margin: "10px 0px" }}
          error={!!errors["seriesAndNumber"]}
          helperText={errors["seriesAndNumber"]}
        />
        <TextField
          type="text"
          name="note"
          label={Vocabulary.note}
          variant="standard"
          fullWidth
          value={customer.personalData.note}
          onChange={(e) => {
            const newCustomer = structuredClone(customer);
            newCustomer.personalData.note = e.target.value;
            handleChangeCustomerDetails(newCustomer);
          }}
          style={{ margin: "10px 0px" }}
        />
      </div>
    </Grid>
  );
}
